var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "profile-field__title",
          class: {
            "profile-field__title--required": _vm.field.required,
          },
        },
        [_vm._v(" Паспортные данные ")]
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col col-6 col-md-2 series" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("c-input", {
                attrs: {
                  "floating-label": "Серия",
                  clearable: true,
                  "max-length": 255,
                  invalid: !!_vm.errors.common || !!_vm.errors.series,
                  error: _vm.errors.series,
                },
                model: {
                  value: _vm.series,
                  callback: function ($$v) {
                    _vm.series = $$v
                  },
                  expression: "series",
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "col col-6 col-md-2 number" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("c-input", {
                attrs: {
                  "floating-label": "Номер",
                  clearable: true,
                  "max-length": 255,
                  invalid: !!_vm.errors.common || !!_vm.errors.number,
                  error: _vm.errors.number,
                },
                model: {
                  value: _vm.number,
                  callback: function ($$v) {
                    _vm.number = $$v
                  },
                  expression: "number",
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "col col-12 col-md-5 issued-by" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("c-input", {
                attrs: {
                  "floating-label": "Кем выдан",
                  clearable: true,
                  "max-length": 255,
                  invalid: !!_vm.errors.common || !!_vm.errors.issuedBy,
                  error: _vm.errors.issuedBy,
                },
                model: {
                  value: _vm.issuedBy,
                  callback: function ($$v) {
                    _vm.issuedBy = $$v
                  },
                  expression: "issuedBy",
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "col col-6 col-md-2 col-lg-3 col-xl-2 date" },
          [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("c-input", {
                  ref: "date",
                  attrs: {
                    type: "date",
                    placeholder: "00.00.0000",
                    label: "Дата выдачи",
                    icon: "calendar",
                    editable: true,
                    selects: true,
                    clearable: true,
                    "icon-right": true,
                    invalid: _vm.errors.common || _vm.errors.issueDate,
                    error: _vm.errors.issueDate,
                  },
                  model: {
                    value: _vm.issueDate,
                    callback: function ($$v) {
                      _vm.issueDate = $$v
                    },
                    expression: "issueDate",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm.error && _vm.error.common
        ? _c("error-feedback", {
            attrs: { text: _vm.error && _vm.error.common },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }